// 税込みの文言を追加する
document.addEventListener('DOMContentLoaded', function() {
    // MutationObserverでDOMの変化を監視
    const observer = new MutationObserver(function(mutationsList, observer) {
        // すべての価格要素を取得
        const priceElements = document.querySelectorAll('.swym-product-grid-price .swym-pr');
        
        // 各価格要素に対して「税込」テキストを追加
        priceElements.forEach(function(priceElement) {
            // 既に「税込」が追加されていないか確認
            if (!priceElement.parentNode.querySelector('.tax')) {
                // 新しい<span>要素を作成し、(税込)テキストを追加
                const taxElement = document.createElement('span');
                taxElement.className = 'tax';
                taxElement.textContent = '（税込）';
                
                // 価格要素の後ろに<span>要素を追加
                priceElement.parentNode.appendChild(taxElement);
            }
        });
    });

    // 監視を開始 (document.body以下の変化を監視)
    observer.observe(document.body, { childList: true, subtree: true });
});



document.addEventListener('DOMContentLoaded', function() {
    // 「から」を削除する関数
    function removeKaraText() {
        const priceElements = document.querySelectorAll('.price-item');

        priceElements.forEach(priceElement => {
            const taxElement = priceElement.querySelector('.tax');
            if (taxElement) {
                const nextSibling = taxElement.nextSibling;
                if (nextSibling && nextSibling.nodeType === Node.TEXT_NODE && nextSibling.textContent.includes('から')) {
                    nextSibling.textContent = nextSibling.textContent.replace('から', '');
                }
            }
        });
    }

    // 「（税込）」を追加する関数
    function addTaxText() {
        const priceElements = document.querySelectorAll('.price-item');

        priceElements.forEach(priceElement => {
            // すでに「（税込）」が存在しない場合にのみ追加
            if (!priceElement.querySelector('.tax')) {
                const taxElement = document.createElement('span');
                taxElement.className = 'tax';
                taxElement.textContent = '（税込）';
                priceElement.appendChild(taxElement);
            }
        });
    }

    // MutationObserverでDOMの変化を監視
    const observer = new MutationObserver(function(mutationsList, observer) {
        addTaxText();   // 「（税込）」を追加
        removeKaraText();  // 「から」を削除
    });

    // ページ全体を監視
    observer.observe(document.body, { childList: true, subtree: true });

    // 初期実行
    addTaxText();
    removeKaraText();

    // 一定間隔で定期的に処理を実行
    setInterval(() => {
        addTaxText();
        removeKaraText();
    }, 1000); // 1秒ごとに実行
});